/* import __COLOCATED_TEMPLATE__ from './sq-loading-manager.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let SqLoadingManager = (_class = class SqLoadingManager extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "root", _descriptor, this);
    this.root = document.querySelector(':root');
    const emberRouteLoadingIndicatorDisplay = getComputedStyle(this.root).getPropertyValue('--ember-route-loading-indictor-display');
    if (!emberRouteLoadingIndicatorDisplay) {
      /*
        The dashboard rails server serves a pre-loader from application.html.erb to improve First Contentful Paint; unfortunately, when combined with ember's loader,
        this confuses the browser APIs when trying to measure Largest Contentful Paint as it's reasonably unexpected that there are multiple loaders.
        We want to hide the ember router loaders to avoid this.
      */
      this.root.style.setProperty('--ember-route-loading-indictor-display', 'none');
    }
  }
  willDestroy(...args) {
    super.willDestroy(...args);
    /*
      This will allow the router loader to display when navigating between routes as well as
      for pages which accidentally rerender the loader
    */
    this.root.style.setProperty('--ember-route-loading-indictor-display', 'block');
    const preloadingLogoContainer = document.querySelector('.preloading-logo-container');

    /*
      Remove the pre-loader served from the dashboard rails server html response defined in application.html.erb
    */
    if (preloadingLogoContainer) {
      preloadingLogoContainer.remove();
      performance.mark('end-dashboard-app-load');
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "root", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
})), _class);
export { SqLoadingManager as default };